import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { authAPI } from '../../services/api';
import './Onboarding.css';

const slides = [
  { image: '/images/onboarding.image.1.png', title: 'Welcome to Crunchy', text: 'Discover and share amazing recipes from a community of food lovers.', color: 'var(--black)' },
  { image: '/images/onboarding.image.2.png', title: 'Create & Share', text: 'Add your own recipes with photos, categories, and dietary info.', color: 'var(--orange)' },
  { image: '/images/onboarding.image.3.png', title: 'Explore & Collect', text: 'Search by category, save favorites, and follow your favorite chefs.', color: 'var(--cream-dark)' },
];

export default function OnboardingPage() {
  const [step, setStep] = useState(0);
  const navigate = useNavigate();
  const { updateUser } = useAuth();

  const handleFinish = async () => {
    try {
      await authAPI.completeOnboarding({ didOnboarding: true });
      updateUser({ didOnboarding: true });
      navigate('/onboarding/preferences');
    } catch {
      navigate('/onboarding/preferences');
    }
  };

  return (
    <div className="onboarding-page">
      <div className="onboarding-card card">
        <div className="onboarding-slide fade-in" key={step}>
          <img src={slides[step].image} alt="" className="onboarding-image" />
          <h2 style={{ color: slides[step].color }}>{slides[step].title}</h2>
          <p>{slides[step].text}</p>
        </div>

        <div className="onboarding-dots">
          {slides.map((_, i) => (
            <div key={i} className={`dot ${i === step ? 'active' : ''}`} />
          ))}
        </div>

        <div className="onboarding-actions">
          {step < slides.length - 1 ? (
            <>
              <button className="btn btn-secondary" onClick={handleFinish}>Skip</button>
              <button className="btn btn-primary" onClick={() => setStep(step + 1)}>Next</button>
            </>
          ) : (
            <button className="btn btn-primary btn-lg" onClick={handleFinish}>Get Started</button>
          )}
        </div>
      </div>
    </div>
  );
}
